module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKXGUdhvIqOjjg.26fe0cf9.woff2";